/*
 * The Belgian Brewer: What's on venue filter (sections/tbb-events.liquid).
 * Buttons with aria-pressed show all events or only one venue's; an empty message appears
 * when a venue has none. Without this script every event is listed.
 */
function setUp(root) {
  if (root.dataset.tbbReady) return;
  root.dataset.tbbReady = 'true';

  const buttons = root.querySelectorAll('[data-tbb-filter]');
  const events = root.querySelectorAll('[data-tbb-events-list] > li');
  const empty = root.querySelector('[data-tbb-events-empty]');
  if (!buttons.length || !events.length) return;

  buttons.forEach((button) =>
    button.addEventListener('click', () => {
      const venue = button.dataset.tbbFilter;
      buttons.forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
      let shown = 0;
      events.forEach((event) => {
        const match = venue === 'all' || event.dataset.tbbVenue === venue;
        event.hidden = !match;
        if (match) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    })
  );
}

const init = (root = document) => root.querySelectorAll('[data-tbb-events]').forEach(setUp);
init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
